import { __assign } from "tslib";
import React from 'react';
import * as Styled from './grid.styled';
export var Grid = function (_a) {
    var children = _a.children, attributes = _a.attributes, $gridCardSizes = _a.$gridCardSizes;
    return (React.createElement(Styled.ShowroomLiteGrid, __assign({ "$gridCardSizes": $gridCardSizes }, attributes), children));
};
